import { micromodal } from "micromodal";

export function modal() {
    MicroModal.init();
    if (window.document.body.id === 'single' || 'business') {
        function modal(modalBtn,modalId) {
            const modalButton = document.querySelector(modalBtn);
            modalButton.addEventListener("click", () => {
                if (modalButton.classList.contains("is-open")) {
                    modalButton.ariaExpanded = false;
                    MicroModal.close(modalId, {
                        awaitCloseAnimation: true,
                    });
                    modalButton.classList.remove("is-open");
                } else {
                    modalButton.ariaExpanded = true;
                    MicroModal.show(modalId, {
                        disableScroll: true, // ページスクロールを無効に
                        awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
                        onClose: () => {
                            modalButton.ariaExpanded = false;
                            modalButton.classList.remove("is-open");
                        }
                    });
                    modalButton.classList.add("is-open");
                }
            });
        }
        if (window.document.body.id === 'single') {
            modal(".js-modalButton1","modal-1");
        } else if (window.document.body.id === 'business') {
            modal(".js-modalButton2","modal-2");
        }
    }
}